import { HelpParameters, Help, HelpPanelColor} from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_ResponsivePIXIApp } from "../SlotGameType1_ResponsivePIXIApp";
	export class BurningHot_ResponsivePIXIApp extends SlotGameType1_ResponsivePIXIApp {		
		protected override helpFactory: IHelpFactory = new BurningHotHelpFactory();
        //LED COLOR
		protected override ColorLed:string="250,0,0\n";

		constructor(multigameParams: MultigameParams, initData: SlotGameInitData , gameName : string = "BurningHot") {
			super(multigameParams, initData, gameName);
			this.spinnableReelsParams.topBorderWidth = 0;
			this.spinnableReelsParams.bottomBorderWidth = 0;
		}
	        //SEND COLOR 
		protected override color: RewardColor ={
                color: "white",
                coloroutherStroke: "black",
                colorinnerStroke: "red",
        }
    }

    //Help Colorized
    class BurningHotHelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new BurningHotHelp(params);
        }
    }

    class BurningHotHelp extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
            let color: HelpPanelColor = {
                backgroundPanelColor: "linear-gradient(rgb(15,19,89),rgb(45,51,166), rgb(90,97,242),rgb(45,51,166),rgb(15,19,89)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }
// }
